import { render, staticRenderFns } from "./ReservesRecords.vue?vue&type=template&id=f40dc030&scoped=true"
import script from "./ReservesRecords.vue?vue&type=script&lang=js"
export * from "./ReservesRecords.vue?vue&type=script&lang=js"
import style0 from "./ReservesRecords.vue?vue&type=style&index=0&id=f40dc030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40dc030",
  null
  
)

export default component.exports